import { formatDate, isValid, parseISO } from "date-fns";

const SHORT_MONTH_DAY_YEAR = "MMM d, yyyy";

const formatDateString = (
  date: string | Date | null | undefined,
  format: string,
): string => {
  if (!date) {
    return "";
  }
  const actualDate = typeof date === "string" ? parseISO(date) : date;
  if (!isValid(actualDate)) {
    return "";
  }
  return formatDate(actualDate, format);
};

export { formatDateString, SHORT_MONTH_DAY_YEAR };
